import { Card } from '../ui/Card';
import { HopperIcon } from '../ui/icons/HopperIcon';
import { UserContextPanel, type UserContextActions, type UserContextData } from '../userContext/UserContext';

type FeedContextSidebarProps = {
  userContext: UserContextData;
  actions: UserContextActions;
  cityName: string;
};

export function FeedContextSidebar({
  userContext,
  actions,
  cityName,
}: FeedContextSidebarProps) {
  const totalVisits = userContext.totalVisits;
  const streakDays = userContext.streakDays;
  const cityVisits = userContext.cityVisits;
  const followingCount = userContext.followingCount;

  return (
    <div className="pulse-context-column">
      <UserContextPanel data={userContext} actions={actions} showGuest avatarShape="rounded-square" />

      {userContext.authenticated && (
        <Card className="pulse-context-card pulse-streak-card">
          <span className="pulse-context-card__icon"><HopperIcon name="fire" size={22} /></span>
          <span>
            <small>Серия визитов</small>
            <strong>{streakDays === null ? 'Данные обновляются' : streakDays > 0 ? `${streakDays} дней подряд` : 'Начните серию'}</strong>
          </span>
        </Card>
      )}

      <Card className="pulse-context-card">
        <span className="pulse-context-card__icon"><HopperIcon name="pin" size={22} /></span>
        <span>
          <small>Ваш город</small>
          <strong>{cityName}</strong>
          <em>{userContext.authenticated ? (cityVisits === null ? 'Визиты обновляются' : `${cityVisits} визитов`) : 'Городская лента'}</em>
        </span>
      </Card>

      <Card className="pulse-quick-stats">
        <button type="button" onClick={userContext.authenticated ? actions.openVisits : undefined} disabled={!userContext.authenticated}>
          <strong>{totalVisits === null ? '—' : totalVisits}</strong><span>Посещений</span>
        </button>
        <button type="button" onClick={userContext.authenticated ? actions.openFriends : undefined} disabled={!userContext.authenticated}>
          <strong>{followingCount === null ? '—' : followingCount}</strong><span>Подписки</span>
        </button>
        <div><strong>—</strong><span>Маршрутов</span><small>скоро</small></div>
      </Card>
    </div>
  );
}
